"use strict";
/**
 * @packageDocumentation
 * @module RegistrationWorkflowContextProvider
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationWorkflowContextProvider = void 0;
var react_1 = __importStar(require("react"));
var context_1 = require("./context");
var RegistrationWorkflowContextProvider = function (props) {
    // Extract the needed properties out
    // Context value will not change unless a sub function is changed
    // NOTE: When adding new props to RegistrationWorkflowContextProps be sure
    // to also add them here so the parameters are copied.
    var currentScreen = props.currentScreen, totalScreens = props.totalScreens, nextScreen = props.nextScreen, previousScreen = props.previousScreen, screenData = props.screenData, updateScreenData = props.updateScreenData, isInviteRegistration = props.isInviteRegistration;
    var memoizedProps = (0, react_1.useMemo)(function () {
        var propsForContext = {
            currentScreen: currentScreen,
            totalScreens: totalScreens,
            nextScreen: nextScreen,
            previousScreen: previousScreen,
            screenData: screenData,
            updateScreenData: updateScreenData,
            isInviteRegistration: isInviteRegistration,
        };
        return propsForContext;
    }, [currentScreen, totalScreens, nextScreen, previousScreen, screenData, updateScreenData, isInviteRegistration]);
    return (react_1.default.createElement(context_1.RegistrationWorkflowContext.Provider, { value: memoizedProps }, props.children));
};
exports.RegistrationWorkflowContextProvider = RegistrationWorkflowContextProvider;
